import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import MainContext from 'context/main';
import Heading from 'components/shared/heading';
import Button from 'components/shared//button';
import SettingsItem from './settings-item';

import styles from './settings.module.scss';

const cx = classNames.bind(styles);

const Settings = ({ handleCloseModal, handleAcceptClick }) => {
  const [nonEssentialValue, setNonEssentialValue] = useState(true);

  const handleNonEssentialChange = () => setNonEssentialValue(!nonEssentialValue);

  const handleButtonClick = () => {
    const settings = { nonEssentialValue };
    handleAcceptClick(settings);
    handleCloseModal();
  };

  const {
    sharedBlocks: {
      cookieBanner: {
        acf: {
          settingsTitle,
          settings1Title,
          settings1Description,
          settings1LinkText,
          settings1Link,
          settings2Title,
          settings2Description,
          settings2LinkText,
          settings2Link,
          settingsButtonText,
        },
      },
    },
  } = useContext(MainContext);

  return (
    <div className={cx('wrapper')}>
      <Heading className={cx('title')} tag="h2" size="lg">
        {settingsTitle}
      </Heading>

      <SettingsItem
        title={settings1Title}
        description={settings1Description}
        linkName={settings1LinkText}
        linkURL={settings1Link.url}
        isChecked
        isDisabled
      />

      <SettingsItem
        title={settings2Title}
        description={settings2Description}
        linkName={settings2LinkText}
        linkURL={settings2Link.url}
        isChecked={nonEssentialValue}
        onChange={handleNonEssentialChange}
      />

      <div className={cx('button-wrapper')}>
        <Button
          className={cx('button')}
          size="sm"
          theme="accent-primary"
          onClick={handleButtonClick}
        >
          {settingsButtonText}
        </Button>
      </div>
    </div>
  );
};

Settings.propTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  handleAcceptClick: PropTypes.func.isRequired,
};

export default Settings;
